import { useCallback } from "react";
import { useSWRConfig } from "swr";
import { unstable_serialize } from "swr/infinite";
import { AgentMessage } from "@/models/agent/message";
import { createThreadMessagesInfiniteKeyLoader } from "./useThreadMessagesInfinite";

export const useThreadMessageMutations = (threadId?: string) => {
  const { mutate } = useSWRConfig();

  const pushOptimisticMessage = useCallback((message: AgentMessage) => {
    if (!threadId) return;

    const key = unstable_serialize(createThreadMessagesInfiniteKeyLoader(threadId));

    mutate(
      key,
      (currentPages?: AgentMessage[][]) => {
        if (!currentPages || currentPages.length === 0) return [[message]];

        const [firstPage, ...rest] = currentPages;
        const existingIndex = firstPage.findIndex((m) => m.id === message.id);
        if (existingIndex !== -1) {
          const updatedFirstPage = [...firstPage];
          updatedFirstPage[existingIndex] = message;
          return [updatedFirstPage, ...rest];
        }

        return [[message, ...firstPage], ...rest];
      },
      { revalidate: false },
    );
  }, [threadId, mutate]);

  return { pushOptimisticMessage };
};
